import request from "@/utils/request";

/**
 * 获取 学员信息列表 -学员公海和所有 数据
 * @param param
 * @returns {*}
 */
export const selectPageStudent = (param) => {
    return request({
        url: '/sys/studentRecord/selectPageStudent',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 分配学生
 * @param param
 * @returns {*}
 */
export const allocationStudent = (param) => {
    return request({
        url: '/sys/studentRecord/allocation',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

export const selectTraineePage = (param) => {
    return request({
        url: '/sys/trainee/selectTraineePage',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
}

export const exportTrainee = (param) => {
    return request({
        url: '/sys/trainee/exportTrainee',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
}



export const selectOrderDivertPage = (param) => {
    return request({
        url: '/sys/trainee/selectOrderDivertPage',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
}

export const exportOrderDivert = (param) => {
    return request({
        url: '/sys/trainee/exportOrderDivert',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
}
